import React from "react"
import HTMLReactParser from "html-react-parser"
// import { FeaturedBlock } from "components/FeaturedBlock"
import { CustomCTA } from "components/CustomCTA"
import { StepByStep } from "components/StepByStep"
import { Checklist } from "components/Checklist"
import { ContactForm } from "components/ContactForm"

// CTA Block
const getFeatureBlock = attribs => {
  const {
    heading,
    message,
    link,
    linktext,
    imageposition,
    buttontext,
    srcset,
    sourceurl,
  } = attribs

  return <CustomCTA attribs={attribs} />
}

const getSteps = attribs => {
  const data = JSON.parse(attribs.steps)
  console.log(attribs.steps)

  return <StepByStep data={data} />
}

const getChecklist = attribs => {
  const data = JSON.parse(attribs.items)

  return <Checklist data={data} />
}

// Parse Custom Blocks
export function parseBlockContent(markup) {
  // console.log(markup)

  const Content = HTMLReactParser(markup, {
    replace: ({ attribs }) => {
      if (!attribs) return

      if (attribs.class && attribs.class.includes("acf-block--cta")) {
        return getFeatureBlock(attribs)
      } 
      if (attribs.class && attribs.class.includes("acf-block--contact-form")) {
        return <ContactForm />
      }

      if (attribs.class && attribs.class.includes("acf-block--steps")) {
        return getSteps(attribs)
      }
      if (attribs.class && attribs.class.includes("acf-block--checklist")) {
        return getChecklist(attribs)
      }
    },
  })

  return Content
}
